const TenantAPI = process.env.NEXT_PUBLIC_API_URL;
import API from "../API";
export async function TenantCustomDomainAPI(hostname) {
  const removeWWW = hostname?.replace("www.", "");
  const res = await fetch(TenantAPI + `/common/custom-domain/${removeWWW}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then((data) => {
      console.log('TenantCustomDomainAPI', data)
      return data;
    });

  return res;
}

export const GetWebsiteDetailsApi = async () => {
  try {
    const response = await API.get(`/common/website/tenant`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetCompanyDetailsApi = async () => {
  try {
    const response = await API.get(`/common/api/companydetails`);
    return response;
  } catch (error) {
    throw error;
  }
};
